module.exports = __webpack_public_path__ + "static/puma-1-ddab1d666cba8c821535a8a280d0a9a1.jpg";